const style = {
  actions: {
    width: 750,
  },
  greyAction: {
    color: "grey.600",
    borderColor: "grey.200",
  },
  headerBtns: {
    marginLeft: "32px",
  },
  pageHeadingWrapper: {
    margin: "24px 0 40px 48px",
    position: "relative",
  },
  pageHeading: {
    // color: theme.palette.grey[900],
    color: "black",
    fontSize: 24,
    // fontFamily: theme.font.medium,
    fontWeight: 500,
    letterSpacing: 0.08,
  },
  pageHeadingCaption: {
    color: "grey.500",
    // fontFamily: theme.font.regular,
    fontSize: 12,
    letterSpacing: 0.17,
  },
  pageHeadingMarker: {
    background: "#7f5bdb",
    height: 70,
    width: 4,
    position: "absolute",
    left: -24,
    top: 0,
  },
  progressBtn: {
    position: "absolute",
    top: "60%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  switchLabel: {
    top: 1,
  },
};

export default style;
